import React, { useRef, useState } from "react";
import { LuBookOpen, LuImagePlus, LuPalette, LuPlus } from "react-icons/lu";
import { components } from "../../design/tokens";

interface AttachmentsBtnProps {
  onAddImageClick: () => void;
  onPromptLibraryClick?: () => void;
  onDesignLibraryClick?: () => void;
  className?: string;
  iconSize?: number;
  isDisabled?: boolean;
  dropdownPosition?: "top" | "bottom";
}

export const AttachmentsBtn: React.FC<AttachmentsBtnProps> = ({
  onAddImageClick,
  onPromptLibraryClick,
  onDesignLibraryClick,
  className = "",
  iconSize = 24,
  isDisabled = false,
  dropdownPosition = "bottom",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleAddImageClick = () => {
    setIsOpen(false);
    onAddImageClick();
  };

  const handlePromptLibraryClick = () => {
    setIsOpen(false);
    onPromptLibraryClick?.();
  };

  const handleDesignLibraryClick = () => {
    setIsOpen(false);
    onDesignLibraryClick?.();
  };

  return (
    <div className="relative flex gap-4 items-center" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`${className} flex items-center justify-center`}
        type="button"
        disabled={isDisabled}
      >
        <LuPlus size={iconSize} />
      </button>

      {isOpen && (
        <div
          className={`absolute left-0 ${
            dropdownPosition === "top"
              ? "bottom-[calc(100%+8px)]"
              : "bottom-0"
          } ${components.dropdown.container}`}
        >
          <div role="menu" aria-orientation="vertical">
            <button
              id="attachments-btn-add-image"
              onClick={handleAddImageClick}
              className={components.dropdown.item}
              role="menuitem"
            >
              <LuImagePlus className="mr-3 h-5 w-5" />
              Add image
            </button>
            {onDesignLibraryClick && (
              <button
                id="attachments-btn-open-design-library"
                onClick={handleDesignLibraryClick}
                className={components.dropdown.item}
                role="menuitem"
              >
                <LuPalette className="mr-3 h-5 w-5" />
                Design Library
              </button>
            )}
            {onPromptLibraryClick && (
              <button
                id="attachments-btn-open-prompt-library"
                onClick={handlePromptLibraryClick}
                className={components.dropdown.item}
                role="menuitem"
              >
                <LuBookOpen className="mr-3 h-5 w-5" />
                Open Prompt Library
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
